import axios from "axios";
import axiosInstance from "./axiosInstance";

const request = ({ route, data = {}, useAPI = true, timeout = 5000 }) => {
  const formData = new FormData();
  const json = {};
  if (typeof data === "object") {
    Object.keys(data).forEach((key) => {
      if (data[key] instanceof FileList) {
        formData.append("file", data[key][0]);
      } else {
        if (key === "data") {
          const jsonData = {};
          Object.keys(data[key]).forEach((dataKey) => {
            if (data[key][dataKey] instanceof FileList) {
              formData.append("file", data[key][dataKey][0]);
            } else {
              jsonData[dataKey] = data[key][dataKey];
            }
          });
          json.data = jsonData;
        } else {
          json[key] = data[key];
        }
      }
    });
    formData.append("json", JSON.stringify(json));
  }

  return (!process.env.REACT_APP_USE_MOCK_SERVER || !useAPI ? axiosInstance : axios).post(
    route,
    formData,
    { timeout }
  );
};

export default request;
